import config from "../config";
import { send } from "./api";

const getJsonFromApi = (url) => {
  return send(url, "GET");
};

export default getJsonFromApi;
